import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    FiMenu,
    FiX,
    FiGrid,
    FiPlusCircle,
    FiCreditCard,
    FiLogOut,
} from "react-icons/fi";

import logo from "../assets/images/expo-pilot-logo.png";

const Navbar = () => {
    const [mobileOpen, setMobileOpen] =
        useState(false);
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.clear();
        navigate("/");
    };

    const navItems = [
        {
            label: "Dashboard",
            icon: <FiGrid size={18} />,
            href: "/dashboard",
        },
        {
            label: "Ajouter Badge",
            icon: <FiPlusCircle size={18} />,
            href: "/badges/create",
        },
        {
            label: "Mes Badges",
            icon: <FiCreditCard size={18} />,
            href: "/badges",
        },
    ];

    return (
        <header className="sticky top-0 z-50 w-full border-b border-slate-200 bg-white/90 backdrop-blur-xl">
            <div className="max-w-7xl mx-auto px-4 md:px-8">
                <div className="h-20 flex items-center justify-between">
                    {/* LOGO */}
                    <a
                        href="/dashboard"
                        className="flex items-center gap-3"
                    >
                        <div className="h-14 flex items-center justify-center">
                            <img
                                src={logo}
                                alt="Expo Pilot"
                                className="h-12 w-auto object-contain"
                            />
                        </div>
                    </a>

                    {/* DESKTOP NAV */}
                    <nav className="hidden md:flex items-center gap-2">
                        {navItems.map((item, index) => (
                            <a
                                key={index}
                                href={item.href}
                                className="group relative h-12 px-5 rounded-2xl flex items-center gap-2 text-slate-600 hover:text-[#3563E9] hover:bg-[#eef4ff] transition-all font-medium"
                            >
                                <span className="text-lg">
                                    {item.icon}
                                </span>

                                {item.label}

                                <span className="absolute bottom-1 left-1/2 -translate-x-1/2 w-0 h-[3px] rounded-full bg-[#3563E9] group-hover:w-8 transition-all duration-300"></span>
                            </a>
                        ))}
                    </nav>

                    {/* RIGHT */}
                    <div className="flex items-center gap-3">
                        <button
                            onClick={handleLogout}
                            className="hidden md:flex items-center gap-2 px-4 h-12 rounded-2xl bg-red-50 text-red-600 hover:bg-red-100 transition-all font-medium"
                        >
                            <FiLogOut size={18} />
                            Déconnexion
                        </button>

                        {/* MOBILE BTN */}
                        <button
                            onClick={() =>
                                setMobileOpen(
                                    !mobileOpen
                                )
                            }
                            className="md:hidden w-12 h-12 rounded-2xl border border-slate-200 flex items-center justify-center text-slate-700 hover:bg-slate-100 transition-all"
                        >
                            {mobileOpen ? (
                                <FiX size={24} />
                            ) : (
                                <FiMenu size={24} />
                            )}
                        </button>
                    </div>
                </div>
            </div>

            {/* MOBILE MENU */}
            <div
                className={`md:hidden overflow-hidden transition-all duration-300 ${mobileOpen
                    ? "max-h-[400px] opacity-100 border-t border-slate-200"
                    : "max-h-0 opacity-0"
                    }`}
            >
                <div className="px-4 py-5 bg-white space-y-3">
                    {navItems.map((item, index) => (
                        <a
                            key={index}
                            href={item.href}
                            onClick={() =>
                                setMobileOpen(false)
                            }
                            className="h-14 rounded-2xl bg-slate-50 hover:bg-[#eef4ff] hover:text-[#3563E9] px-4 flex items-center gap-3 text-slate-700 transition-all font-medium"
                        >
                            <span className="text-lg">
                                {item.icon}
                            </span>

                            {item.label}
                        </a>
                    ))}
                    <div className="pt-3 border-t border-slate-200">
                        <button
                            onClick={handleLogout}
                            className="w-full h-14 rounded-2xl bg-red-50 hover:bg-red-100 px-4 flex items-center gap-3 text-red-600 transition-all font-medium"
                        >
                            <FiLogOut size={18} />
                            Déconnexion
                        </button>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Navbar;